module.exports = __webpack_public_path__ + "img/9-2.041dd05f.png";